import * as zip from "@zip.js/zip.js";
import { TicketOrderReceipt } from "@greeter/core";

/**
 * TODO: Turn this into an util?
 * Converts a Base64 string to a Blob object.
 * @param {string} base64Data - The base64 string.
 * @param {string} contentType - The MIME type (e.g., 'image/png').
 */
function base64ToBlob(base64Data: string, contentType: string = "") {
  const byteCharacters = atob(base64Data);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: contentType });
}

function download(blob: Blob, fileName: string) {
  const url = window.URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.style.display = "none";
  anchor.href = url;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  setTimeout(() => {
    window.URL.revokeObjectURL(url);
    document.body.removeChild(anchor);
  }, 1_000);
}

export async function downloadReceiptAndTickets(d: TicketOrderReceipt) {
  const blobWriter = new zip.BlobWriter("application/zip");
  const writer = new zip.ZipWriter(blobWriter);
  await Promise.all([
    writer
      .add("kvittering.pdf", new zip.BlobReader(base64ToBlob(d.receiptPdf)))
      .catch((e) => console.error("Could not fetch pdf version", e)),
    ...d.ticketDocuments.map((doc) => {
      return writer
        .add(doc.fileName, new zip.BlobReader(base64ToBlob(doc.data)))
        .catch((e) =>
          console.error(
            `Could not write ticket document, ${doc.id},to the zip`,
            e
          )
        );
    }),
  ]);
  const b = await writer.close();
  download(b, "billetter");
}
